import { NavTreeNode } from 'hooks/useNavigationLinks';

export function stripQuery(to: string): string {
  return to.split('?')[0];
}

export function collectActiveAncestorIds(
  nodes: NavTreeNode[],
  pathname: string,
): Set<string> {
  const activeIds = new Set<string>();

  function walk(node: NavTreeNode): boolean {
    if (node.children && node.children.length > 0) {
      const hasActiveChild = node.children.some(walk);
      if (hasActiveChild) activeIds.add(node.id);
      return hasActiveChild;
    }

    if (!node.to) return false;
    return stripQuery(node.to) === pathname;
  }

  nodes.forEach(walk);
  return activeIds;
}

export function nodeTextMatches(
  node: NavTreeNode,
  tokens: string[],
  ancestorText: string,
): boolean {
  const hay = `${ancestorText} ${node.title} ${node.subtitle ?? ''}`
    .toLowerCase()
    .trim();
  return tokens.every(token => hay.includes(token));
}

export function filterNavTreeByQuery(
  nodes: NavTreeNode[],
  tokens: string[],
  ancestorText = '',
): NavTreeNode[] {
  return nodes.reduce<NavTreeNode[]>((out, node) => {
    const selfMatch = nodeTextMatches(node, tokens, ancestorText);
    if (!node.children?.length) {
      if (node.to && selfMatch) out.push(node);
      return out;
    }
    const nodeAccText = `${ancestorText} ${node.title}`.trim();
    const filteredKids = filterNavTreeByQuery(
      node.children,
      tokens,
      nodeAccText,
    );
    if (selfMatch) {
      out.push({
        ...node,
        children:
          filteredKids.length > 0 ? filteredKids : [...node.children],
      });
    } else if (filteredKids.length > 0) {
      out.push({ ...node, children: filteredKids });
    }
    return out;
  }, []);
}

export function collectAllBranchIds(nodes: NavTreeNode[]): string[] {
  const ids: string[] = [];
  function walk(node: NavTreeNode) {
    if (node.children?.length) {
      ids.push(node.id);
      node.children.forEach(walk);
    }
  }
  nodes.forEach(walk);
  return ids;
}
